import { render } from "./Merlin.vue?vue&type=template&id=80ff46d4&scoped=true&ts=true"
import script from "./Merlin.vue?vue&type=script&lang=ts"
export * from "./Merlin.vue?vue&type=script&lang=ts"

import "./Merlin.vue?vue&type=style&index=0&id=80ff46d4&scoped=true&lang=scss"
import "./Merlin.vue?vue&type=style&index=1&id=80ff46d4&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80ff46d4"]])

export default __exports__